import $ from 'jquery';
import ko from 'knockout';

/**
 * Binding to make an element act as a drop zone for file uploads. Child elements within the element will
 * trigger the "dragleave" so a counter is used to determine when enter and leave events occurs just on
 * the element and not child elements.
 */
export const fileDropZone = {
  init: function (element, valueAccessor) {

    var dropZoneElement = $(element);
    var addFileUploadsCallback = valueAccessor();
    var counter = 0;

    dropZoneElement.on('dragover', function (e) {
      e.stopPropagation();
      e.preventDefault();
    });

    dropZoneElement.on('dragenter', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter++;

      dropZoneElement.css('background-color', '#FDFFB7');
      dropZoneElement.css('border-style', 'dashed');
    });

    dropZoneElement.on('dragleave', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter--;

      if (counter === 0) {
        dropZoneElement.css('background-color', '');
        dropZoneElement.css('border-style', 'solid');
      }
    });

    dropZoneElement.on('drop', function (e) {
      e.stopPropagation();
      e.preventDefault();

      counter = 0;
      dropZoneElement.css('background-color', '');
      dropZoneElement.css('border-style', 'solid');

      getFiles(e.originalEvent.dataTransfer).then(function (files) {
        if (files && files.length > 0) {
          addFileUploadsCallback(files);
        }
      }).catch(function () {
      });
    });

    function getFiles(dataTransfer) {
      return new Promise(function (resolve, reject) {
        if (dataTransfer.items) {
          // if it is possible verify that we don't upload a folder
          ko.utils.arrayForEach(dataTransfer.items, function (item) {
            var entry = null;

            if (item.webkitGetAsEntry) {
              entry = item.webkitGetAsEntry();
            } else if (item.getAsEntry) {
              entry = item.getAsEntry();
            }
            if (entry && entry.isDirectory) {
              reject(new Error('Folders are not allowed'));
            }
          });

        }

        resolve(dataTransfer.files);
      });
    }
  }
};
